import * as Yup from 'yup';

const usersValidationSchema = (id) => {
  let baseSchema = {
    firstName: Yup.string()
      .max(50, 'First Name must be at most 50 characters')
      .required('First Name is required'),
    lastName: Yup.string()
      .max(50, 'Last Name must be at most 50 characters')
      .required('Last Name is required'),
    displayEmail: Yup.string()
      .email('Invalid Email')
      .required('Email is required'),
    username: Yup.string().required('Username is required'),
    mobile: Yup.string(),
    phone: Yup.string(),
    password: Yup.string(),
    department: Yup.string().required('Department is required'),
    roleId: Yup.string().required('Role is required'),
  };
  if (id != null) {
    baseSchema.password = baseSchema.password.notRequired();
  } else {
    baseSchema.password = baseSchema.password.min(6, 'Password must be at least 6 characters')
    .max(20, 'Password can be at most 20 characters')
    .required('Password is required');
  }
  return Yup.object().shape(baseSchema);
};
export default usersValidationSchema;
